import { render, staticRenderFns } from "./PointOfSalesMultipleSelect.vue?vue&type=template&id=6cc483ee&"
import script from "./PointOfSalesMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./PointOfSalesMultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports